export class IsNullOrEmptyValidator {
    public static Validate(control): any {
        if (control.value && control.value.toString().trim().length > 0) {
            return null;
        }

        return {
            isNullOrEmpty: true
        };
    }
}
